
import Swiper from 'swiper'
import Navigation from 'swiper/modules/navigation'
import Pagination from 'swiper/modules/pagination'

import 'swiper/swiper-bundle.css'

import ArrowLeftIcon from '~/assets/images/arrow-left-s-line-icon.svg?inline'
import ArrowRightIcon from '~/assets/images/arrow-right-s-line-icon.svg?inline'

export default {
  components: {
    ArrowLeftIcon,
    ArrowRightIcon,
  },

  mounted() {
    this.swiper = new Swiper('.swiper', {
      modules: [Navigation, Pagination],

      grabCursor: true,
      loop: true,

      spaceBetween: 10,
      slidesPerView: 1.1,
      centeredSlides: true,

      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 30,
          centeredSlides: false,
        },
        960: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },

      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        modifierClass: 'carousel-pagination-',
        renderBullet: (index, className) => `
        <button class="${className} carousel-page-control">
            <span class="sr-only">
                ${this.$gettext('Carousel page:')} ${index + 1}
            </span>
        </button>`,
      },

      // Navigation arrows
      navigation: {
        prevEl: this.$refs.buttonPrev,
        nextEl: this.$refs.buttonNext,
      },
    })
  },
}
